import { forwardRef, useImperativeHandle, useState } from "react";
import { Button } from "@telegram-apps/telegram-ui";
import { useTranslation } from "react-i18next";
import { BaseModal, SafeAreaBottom } from "~/components/widget";
import { Qrcode } from "~/components/Qrcode/Qrcode";

export type ModalQrCodeHandle = {
    open: () => void;
};
// 定义组件的 props 类型
interface ModalQrCodeProps {
    invite_link?: string;
}

export const ModalQrCode = forwardRef<ModalQrCodeHandle, ModalQrCodeProps>(
    ({ invite_link = "" }, ref) => {
        const [open, setOpen] = useState(false);
        const { t } = useTranslation();

        useImperativeHandle(ref, () => ({
            open: () => {
                setOpen(true);
            },
        }));

        const onOpenChange = (open: boolean) => {
            if (!open) {
                setOpen(false);
            }
        };

        return (
            <BaseModal
                open={open}
                onOpenChange={onOpenChange}
                className="z-[9999]"
            >
                <div className=" text-center text-text_1 font-Semibold text-h5 pt-[40px]">
                    {t("invite_qr_title")}
                </div>
                <div className=" text-center text-text_2 text-body3 mt-1">
                    {t("invite_qr_title_desc")}
                </div>
                <div className="pt-[20px] pb-[40px]">
                    <Qrcode
                        qrcodeValue={invite_link}
                        rerQrCodeClassName="mt-[0px]"
                    />
                </div>
                <div className="px-[16px] pb-[20px]">
                    <Button
                        className="w-full h-[54px] bg-bg_2 font-Semibold text-text_1"
                        onClick={() => {
                            setOpen(false);
                        }}
                    >
                        <span className="text-h6">{t("btn_close")}</span>
                    </Button>
                </div>
                <SafeAreaBottom />
            </BaseModal>
        );
    }
);
